export default defineNuxtRouteMiddleware((to, from) => {
  const { emitEvent } = analyticsUtils();

  emitEvent('navigation', { routeChange: `${from.path} -> ${to.path}` });
});
